module.exports = __webpack_public_path__ + "img/SketchPng16ee377bf3900b894ac1a754b3ddf9a2644c0d6562e303bb552757bf414514b1.27e83c9d.png";